import React from "react";

import Tooltip from "../Tooltip";
import * as S from "./styled";

const HomeClaimHeaderMinimal = () => (
  <S.HeaderContainer>
    <S.Heading>StreetEasy Valuation</S.Heading>
    <S.TooltipWrapper>
      <Tooltip title="What is the StreetEasy Valuation?">
        The StreetEasy Valuation is a beta product feature that gives
        StreetEasy&apos;s estimated market value. It is not an appraisal. Use it
        as a starting point to determine a home&apos;s value, and consider
        partnering with a listing agent to learn more.
      </Tooltip>
    </S.TooltipWrapper>
  </S.HeaderContainer>
);

export default HomeClaimHeaderMinimal;
